/**
 * Sohbet listesindeki özet satırı (9.3.3.5 · D-586).
 *
 * Liste `meetup` ve `call` dışındaki HER türde ham içeriği yazıyordu: görselde,
 * videoda ve seste depo adresi, konum ve sipariş kartlarında ise JSON. Karşı
 * hesaptan bakıldığında ilk görülen şey buydu — `{"shareId":3}`.
 *
 * Adres göstermek yalnız çirkin değil: medya adresleri kısa ömürlü imzalı
 * okuma adresleri (D-563), yani listeye bir imza yazıyorduk.
 */
export type PreviewType = string | null | undefined;

const ETIKET: Record<string, string> = {
  image: 'message.photo',
  video: 'message.videoShort',
  voice: 'message.voiceShort',
  location: 'message.locationTitle',
  voice_order: 'message.voiceOrderTitle',
  location_share: 'message.liveLocationCardTitle',
  // 9.34 / D-612 — şifreli satırın içeriği zarftır. Etiketi OLMASAYDI çağıran
  // ham içeriği yazardı, yani listeye JSON düşerdi: bu modülün doğuş sebebi olan
  // kusurun aynısı. Çözülmüş önizlemeyi yerel önbellekten okumak ayrı bir adım;
  // bu etiket, o yokken gösterilen dürüst karşılık.
  encrypted: 'message.encrypted',
};

/**
 * Tür için okunur etiket; bilinmeyen tür ve düz metin için null döner —
 * o durumda çağıran içeriğin kendisini yazar.
 */
export function previewLabelKey(type: PreviewType): string | null {
  return typeof type === 'string' ? ETIKET[type] ?? null : null;
}
